import {initSocket, closeSocket} from "../../Socket/socketIO";
const jwt = require('jsonwebtoken');

const login = (state, action) => {
  localStorage.setItem('casa_token', action.data.token);
  initSocket(action.data.token);
  return {
    isAuthenticated: action.data.success,
    user: action.data.user,
    token: action.data.token,
  };
};

const logout = () => {
  localStorage.removeItem('casa_token');
  closeSocket();
  return {
    isAuthenticated: false,
  };
};

const setAuth = () => {
  try {
    const token = localStorage.getItem('casa_token');
    const { user } = jwt.decode(token);
    return {
      isAuthenticated: !!token && !!user,
      user,
      token,
    };
  } catch (e) {
    return {
      isAuthenticated: false,
    };
  }
};

export default (state = {}, action) => {
  switch (action.type) {
    case 'LOGIN':
      return login(state, action);
    case 'LOGOUT':
      return logout();
    case 'SET_AUTH':
      return setAuth();
    default:
      return state;
  }
};
